import { Component } from '@angular/core';
@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      <p>ANM COMUNICA - Piattaforma di comunicazione interna riservata agli iscritti ANM</p>
    </span>
    <div class="socials">
      <!--<a href="#" target="_blank" class="ion ion-social-github"></a>-->
      <!--<a href="#" target="_blank" class="ion ion-social-facebook"></a>-->
      <!--<a href="https://www.instagram.com/efestodev/?hl=it" target="_blank" class="ion ion-social-instagram"></a>-->
      <!--<a href="https://www.linkedin.com/company/14803075/" target="_blank" class="ion ion-social-linkedin"></a>-->
    </div>
  `,
})
export class FooterComponent {
}
